import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const businessContactDetail = () => ({
    header : "Business contact, compliance officer, and responsible agent",
    text : [
        "Provide information for a business contact who is responsible for responding to licensing queries and a contact to respond to consumer complaints and compliance.",
        "This might be one individual, or you can provide information for three people."
    ],
    headerRenewal : "Business contact, compliance officer, and responsible agent",
    textRenewal : [
        "Review the information for the business contact who is responsible for responding to licensing queries and the contact to respond to consumer complaints and compliance.",
        "This might be one individual, or you can provide information for three people."
    ],
    navigation : {
        next : ROUTE_PATH.ADDRESS_FOR_SERVICE,
        back : ROUTE_PATH.RJSC_DETAIL_REVIEW
    }
})

const businessContactDetailSlice = createSlice({
    name : "businessContactDetail",
    initialState : businessContactDetail(),
    reducers : {} 
})

export default businessContactDetailSlice.reducer
